import Immutable from 'immutable'

export const FabricationMethod = Immutable.Record({
  id: null,
  name: '',
  description: '',
  minimumOrderQuantity: null
});

export const FabricationMethodMap = Immutable.OrderedMap;